<template>
  <v-row v-show="!hide" no-gutters align="stretch" :class="isPreviewed ? 'indicate-preview' : ''">
    <v-col v-if="showCheckbox" cols="auto" class="hovercol d-flex align-center justify-center px-3"
      @click.stop="toggleCheckbox()">
      <div>
        <v-checkbox :inputValue="isChecked" :value="isChecked" hide-details :ripple="false" ref="checkbox"
          class="ma-0 pa-0 justify-center" style="max-width: 32px !important; max-height: 32px !important;"
          @click.stop="toggleCheckbox()">
        </v-checkbox>
      </div>
    </v-col>
    <v-col cols="0" :style="listItemMaxWidth" @click.middle.exact="$emit('MiddleClick')"
      @click.stop="$emit('PrimaryClick')" class="d-flex align-stretch">
      <slot name="list-item">
      </slot>
    </v-col>
    <v-col v-if="previewable && !isPreviewed" cols="auto" class="hovercol d-flex align-center justify-center px-3"
      @click.stop="openPreview()">
      <v-icon size="20">mdi-view-split-vertical</v-icon>
    </v-col>
    <v-col v-else-if="previewable" cols="auto" class="hovercol d-flex align-center justify-center px-3"
      @click.stop="closePreview()">
      <v-icon size="20"> mdi-arrow-collapse-left</v-icon>
    </v-col>
    <v-hover v-if="showDelete" v-slot="{ hover }">
      <v-col cols="auto" class="hovercol2 d-flex align-center justify-center px-3" @click.stop="handleDelete()">
        <v-icon v-if="!deleteLoading" size="20" v-text="hover ? 'mdi-delete-empty' : 'mdi-delete'">
        </v-icon>
        <v-progress-circular v-else indeterminate size="20" width="2" color="primary">
        </v-progress-circular>
      </v-col>
    </v-hover>
  </v-row>
</template>


<script>
export default {
  name: 'SelectableListItemWrapper',
  props: {
    hide: Boolean,
    showCheckbox: Boolean,
    isChecked: Boolean,
    toggleCheckbox: Function,

    previewable: Boolean,
    isPreviewed: Boolean,
    openPreview: Function,
    closePreview: Function,

    showDelete: Boolean,
    deleteFunc: Function
  },
  components: {},

  data() {
    return {
      deleteLoading: false,
    };
  },

  mounted() {
    //console.log('Mounted SelectableListItemWrapper', this.showDelete, 'func', this.deleteFunc === undefined);
  },

  methods: {
    async handleDelete() {
      this.deleteLoading = true;
      await this.deleteFunc();
      this.deleteLoading = false;
    }
  },

  computed: {
    listItemMaxWidth() {
      var checkboxWidth = this.showCheckbox ? 48 : 0;
      var previewWidth = this.previewable ? 44 : 0;
      var deleteWidth = this.showDelete ? 44 : 0;
      return "max-width: calc(100% - " + (checkboxWidth + previewWidth + deleteWidth) + "px);";
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped>
.indicate-preview {
  border: 1px solid var(--v-primary-base) !important;
  border-right: none !important;
}
</style>